<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon>
          {{ announcement.is_published ? 'mdi mdi-check-circle text-success' : 'mdi mdi-close-circle text-danger' }}
        </v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-card-text> Are you sure you want to <span> {{ announcement.is_published===0?'publish':'hide' }}</span> <b> {{ announcement.title.toUpperCase() }}</b> ? </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      announcement: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true
 
        this.$api.announcements().publish(this.announcement.id, { is_published: this.announcement.is_published === 0 ? 1 : 0 })
          .then(response => {
            this.$emit('published')
            this.$snack({ message: 'Announcement published' })
            this.menu = false
            this.progressing = false
          })
      },
    },
  }
</script>
